import { render, staticRenderFns } from "./Zhgl.vue?vue&type=template&id=03aa1d3d&scoped=true"
import script from "./Zhgl.vue?vue&type=script&lang=js"
export * from "./Zhgl.vue?vue&type=script&lang=js"
import style0 from "./Zhgl.vue?vue&type=style&index=0&id=03aa1d3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03aa1d3d",
  null
  
)

export default component.exports